import { render } from "./ProblemsSection.vue?vue&type=template&id=1a35d976&scoped=true"
import script from "./ProblemsSection.vue?vue&type=script&lang=ts"
export * from "./ProblemsSection.vue?vue&type=script&lang=ts"

import "./ProblemsSection.vue?vue&type=style&index=0&id=1a35d976&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a35d976"

export default script